import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SectorCard = ({ icon: Icon, title, description, link, country }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${country}/${link}`);
  };

  return (
    <div 
      className="bg-white rounded-2xl p-8 shadow-md border border-gray-100 hover:shadow-xl hover:-translate-y-2 hover:border-[#F9A825] transition-all duration-300 ease-in-out cursor-pointer group"
      onClick={handleClick}
      data-testid={`sector-card-${link}`}
    >
      <div className="w-16 h-16 bg-aug-blue-light rounded-lg flex items-center justify-center mb-4 group-hover:bg-aug-blue transition-colors duration-300">
        <Icon className="w-8 h-8 text-aug-blue group-hover:text-white transition-colors duration-300" />
      </div>
      <h3 className="text-2xl font-bold mb-3" style={{ color: '#1B5E20' }}>{title}</h3>
      <p className="text-aug-gray-medium mb-4 leading-relaxed">{description}</p>
      <div className="flex items-center text-aug-blue group-hover:text-aug-green transition-colors duration-300 font-medium">
        <span>Saiba Mais</span>
        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
      </div>
    </div>
  );
};

export default SectorCard;
